.SingleChoiceDropdown {
  position: relative;
  display: flex;
  height: 40px;
  padding: var(--padding-content-xxs);
  align-items: center;
  gap: var(--gaps-text-small);
  align-self: stretch;
  border-radius: var(--border-radius-input-medium);
  border: 1px solid var(--input-default);
  background: var(--background-fill);
  margin-top: 4px;

  &:focus-within {
    border-color: var(--brand-primary) !important;
  }

  &:hover {
    border-color: var(--input-hover);
  }

  &__icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  &__input-wrapper {
    flex: 1;
  }

  &__input {
    outline: none;
    border: none;
    background: transparent;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    color: var(--text-primary);
  }
}
